<template>
   <div>
      <div class="row mt-4">
         <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
               <label class="d-inline-flex align-items-center">
                  Ver 
               <b-form-select v-model="perPage" class="mx-1" size="sm" :options="pageOptions"></b-form-select>registros
               </label>
            </div>
         </div>

         <div class="col-sm-12 col-md-6 mb-3">
            <div id="tickets-table_filter" class="dataTables_filter text-md-right">
               <label class="d-inline-flex align-items-center" style="width: 100%;">
                  Búsqueda:
                  <b-form-input v-model="filter" type="search" placeholder="Buscar..." class="form-control form-control-sm ml-2"></b-form-input>
               </label>
            </div>
         </div>
      </div>
      <div class="table-responsive mb-0">
         <b-table :items="customers" :fields="fields" responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
            <template v-slot:cell(detalles)="data">
               <router-link tag="a" :to="{ name: 'CustomerDetail', params: { codcli: data.item.cod, coddep: data.item.PV }}"><button type="button" class="btn btn-danger btn-sm btn-rounded">Detalle</button></router-link>
            </template>
         </b-table>
      </div>
      <div class="row">
         <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
               <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
               </ul>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   export default {
      props: {
         customers: {
            type: Array,
            default: function() {
            return [];
            }
         }
      },
      data() {
         return {
            pageOptions: [10, 25, 50, 100],
            perPage: 10,
            filter: null,
            filterOn: [],
            fields: [
               { key: "cod", sortable: true },
               { key: "empresa", sortable: true },
               { key: "nombre PV", sortable: true },
               { key: "PV", sortable: true },
               { key: "CP", sortable: true },
               { key: "detalles", sortable: true },
               //{ key: "V.A.A.", sortable: true },
               //{ key: "V.Ejer.", sortable: true }
            ],
            sortBy: "empresa",
            sortDesc: false,
            currentPage: 1,
            totalRows: 1,
         }
      },
      methods: {
         onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
         }
      },
      computed: {
         rows() {
            return this.customers.length;
         }
      }
   };
</script>